/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimTask } from './ClaimTask';
import {
    ClaimTaskFromJSON,
    ClaimTaskFromJSONTyped,
    ClaimTaskToJSON,
} from './ClaimTask';

/**
 * 
 * @export
 * @interface ClaimTasksResponse
 */
export interface ClaimTasksResponse {
    /**
     * 
     * @type {Array<ClaimTask>}
     * @memberof ClaimTasksResponse
     */
    tasks: Array<ClaimTask>;
    /**
     * 
     * @type {any}
     * @memberof ClaimTasksResponse
     */
    count: any | null;
}

/**
 * Check if a given object implements the ClaimTasksResponse interface.
 */
export function instanceOfClaimTasksResponse(value: object): value is ClaimTasksResponse {
    if (!('tasks' in value) || value['tasks'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ClaimTasksResponseFromJSON(json: any): ClaimTasksResponse {
    return ClaimTasksResponseFromJSONTyped(json, false);
}

export function ClaimTasksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimTasksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tasks': ((json['tasks'] as Array<any>).map(ClaimTaskFromJSON)),
        'count': json['count'],
    };
}

export function ClaimTasksResponseToJSON(value?: ClaimTasksResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tasks': ((value['tasks'] as Array<any>).map(ClaimTaskToJSON)),
        'count': value['count'],
    };
}

